import { useTranslation } from 'react-i18next';
import DownloadWidget from '@quicktools/shared-components/components/common/Widgets/DownloadWidget';
import { saveAs } from 'file-saver';
import { useContext } from 'react';

import { AppContext } from '../../store';
import sendWindowMessage from '../../utils/windowMessage';

import useStyles from './styles';

function Download() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { state } = useContext(AppContext);

  const handleDownload = () => {
    // send post message to parent window
    // this message is used by parent apps for analytics
    sendWindowMessage({
      type: 'button-click',
      message: 'click',
    });
    saveAs(state.uploadData?.url, 'BackgroundRemover.png');

    // send post message to parent window
    // this message is used by parent apps for analytics
    sendWindowMessage({
      type: 'button-click',
      message: 'download',
    });
  };

  return (
    <DownloadWidget
      imgContainerClassName={classes.imageContainer}
      type="image"
      imgAlt={t('widget.imgAlt')}
      handleDownload={handleDownload}
      imgSrc={state.uploadData?.url}
    />
  );
}

export default Download;
